"use client";

import { FC, useEffect, useState } from "react";
import Calculator from "../Calculator";
import OverviewDesktop from "./desktop";
import OverviewMobile from "./mobile";
import styles from "./style.module.scss";
import Link from "next/link";
import { useCookies } from "react-cookie";
import { useCryptoCurrenciesStats } from "@/service/queries/cryptoCurrencies";

const Overview: FC<{ coin: string }> = ({ coin }) => {
  let href = "";
  if (coin === "USDT") {
    href = `${process.env.APP_PANEL_URL}/login?redirect=/trade/USDT_TMN`;
  } else {
    href = `${process.env.APP_PANEL_URL}/login?redirect=/trade/${coin}_USDT`;
  }
  const [documentWidth, setDocumentWidth] = useState<number>(1201);
  const [cookies] = useCookies(["access_token", "customer_uuid"]);
  const { data: stats } = useCryptoCurrenciesStats([coin]);
  const data = stats?.crypto_currencies[0];

  useEffect(() => {
    setDocumentWidth(window.innerWidth);

    function handleResize() {
      setDocumentWidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={styles.wrapper}>
      {documentWidth > 900 ? (
        <OverviewDesktop coin={coin} data={data} />
      ) : (
        <OverviewMobile coin={coin} data={data} />
      )}
      <Calculator data={data} coin={coin} />
      <></>
      {documentWidth <= 900 && (
        <div className={styles.startTradeButtonBox}>
          <Link href={href} className={styles.startTradeButton}>
            شروع معامله
          </Link>
        </div>
      )}
    </div>
  );
};

export default Overview;
